module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/icon-help-gray.7c6011b3.svg";